/*
 * Barre à paliers du panier (01/10/2026) — livraison offerte + cadeau (GWP).
 * Rendu seulement : l'ajout / retrait du cadeau reste dans gwp.js.
 *
 * Règles de calcul (identiques à l'existant) :
 *  - livraison : cart.total_price (après remises), comme le bandeau natif du thème ;
 *  - cadeau : somme des original_line_price hors cartes cadeaux et hors ligne _gwp (avant codes), comme gwp.js.
 * Sur le rail, le palier livraison est posé à SPLIT % et le cadeau au bout : la 1re partie suit
 * la livraison, la 2e suit le sous-total cadeau.
 *
 * Événements écoutés : theme:cart:change (panier à jour), gwp:declined (cadeau retiré par la cliente),
 * gwp:gift_unavailable (rupture). Événement émis : gwp:readd (bouton « Ajouter » après un retrait).
 */
(function () {
  var root = document.querySelector('[data-cart-tiers]');
  var configEl = document.querySelector('[data-cart-tiers-config]');
  if (!root || !configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var STRINGS = config.strings || {};
  var RATE = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
  var SHIP_CENTS = Math.round((parseFloat(config.ship_limit) || 0) * 100 * RATE);
  var GIFT_CENTS = config.gift ? Math.round((parseFloat(config.gift.threshold) || 0) * 100) : 0;
  var SPLIT = 55; // position du palier livraison sur le rail (en %) — garder en phase avec custom.css (.cart-tiers__mark / __label--ship)
  var DECLINED_KEY = 'tkp_gwp_declined';

  var msgEl = root.querySelector('[data-tiers-msg]');
  var fillEl = root.querySelector('[data-tiers-fill]');
  var shipMark = root.querySelector('[data-tiers-mark="ship"]');
  var giftMark = root.querySelector('[data-tiers-mark="gift"]');
  var readdBtn = root.querySelector('[data-tiers-readd]');

  // Le palier cadeau n'a de sens que si le livraison passe avant (49 € < 70 €). Sinon : livraison seule.
  var giftOff = !GIFT_CENTS || (SHIP_CENTS > 0 && SHIP_CENTS >= GIFT_CENTS);
  var giftBlocked = false; // remise cadeau non applicable à ce panier (signalé par gwp.js) : on n'en parle plus
  var lastCart = config.cart || null;
  var prevHadGift = null;
  var declinedLocal = false;

  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}€';
    var value = (Math.max(0, cents) / 100).toFixed(2);
    if (/amount_with_comma_separator/.test(format)) value = value.replace('.', ',');
    return format
      .replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value)
      .replace(/[.,]00(?!\d)/, '')
      .replace(/<[^>]*>/g, '');
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties._gwp === 'true');
  }

  function eligibleCents(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (item.gift_card || isGiftLine(item)) return;
      total += item.original_line_price || 0;
    });
    return total;
  }

  function giftLine(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isGiftLine(items[i])) return items[i];
    }
    return null;
  }

  function isDeclined() {
    if (declinedLocal) return true;
    try { return sessionStorage.getItem(DECLINED_KEY) === '1'; } catch (e) { return false; }
  }

  function clamp(n) {
    return Math.max(0, Math.min(100, n));
  }

  function setMsg(html) {
    if (msgEl && msgEl.innerHTML !== html) msgEl.innerHTML = html;
  }

  // Cadeau coupé (fin d'opération, rupture, autre devise) : gwp.js n'est plus chargé, donc personne ne
  // retire les lignes cadeau restées dans les paniers. On retire celles qui seraient FACTURÉES.
  var cleaning = {};
  function cleanupGifts(cart) {
    if (config.gift || !cart || !cart.items) return;
    var updates = {};
    var count = 0;
    cart.items.forEach(function (item) {
      if (isGiftLine(item) && item.final_line_price > 0 && !cleaning[item.key]) {
        updates[item.key] = 0;
        cleaning[item.key] = true;
        count++;
      }
    });
    if (!count) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (fresh) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: fresh }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function () {});
  }

  function render(cart) {
    if (!cart) return;
    lastCart = cart;

    if (!cart.item_count) {
      root.hidden = true;
      prevHadGift = null;
      declinedLocal = false;
      return;
    }

    var total = cart.total_price || 0;
    var shipOk = SHIP_CENTS <= 0 || total >= SHIP_CENTS;
    var fill = 0;
    var complete = false;
    var showReadd = false;
    var giftDone = false;
    var html;

    var single = giftOff || giftBlocked;
    if (single) {
      if (SHIP_CENTS <= 0) { root.hidden = true; return; }
      if (shipOk) {
        html = STRINGS.ship_done;
        complete = true;
        fill = 100;
      } else {
        html = STRINGS.ship_remaining_html.replace('__AMOUNT__', money(SHIP_CENTS - total));
        fill = (total / SHIP_CENTS) * 100;
      }
    } else {
      var eligible = eligibleCents(cart);
      var line = giftLine(cart);
      var giftOk = eligible >= GIFT_CENTS;
      var giftFree = !!line && line.final_line_price === 0;

      // Retrait manuel du cadeau alors que le panier qualifie toujours : on ne parle plus d'« ajout en cours ».
      if (prevHadGift === true && !line && giftOk) declinedLocal = true;
      if (line) declinedLocal = false;
      prevHadGift = !!line;

      if (!shipOk) {
        html = STRINGS.ship_remaining_html.replace('__AMOUNT__', money(SHIP_CENTS - total));
      } else if (!giftOk) {
        html = STRINGS.gift_remaining_html.replace('__AMOUNT__', money(GIFT_CENTS - eligible));
      } else if (line && giftFree) {
        html = STRINGS.all_done;
        complete = true;
      } else if (line) {
        // Cadeau au panier mais pas remisé (ex. code promo non cumulable) : on ne promet pas « offert ».
        html = STRINGS.gift_in_cart;
      } else if (isDeclined()) {
        html = STRINGS.waiting;
        showReadd = true;
      } else {
        html = STRINGS.adding;
      }

      giftDone = !!line && giftFree;
      if (SHIP_CENTS > 0 && !shipOk) {
        fill = (total / SHIP_CENTS) * SPLIT;
      } else if (giftOk) {
        fill = 100;
      } else {
        var from = SHIP_CENTS > 0 ? SHIP_CENTS : 0;
        var start = SHIP_CENTS > 0 ? SPLIT : 0;
        fill = start + Math.max(0, (eligible - from) / (GIFT_CENTS - from)) * (100 - start);
      }
    }

    setMsg(html);
    if (fillEl) fillEl.style.width = clamp(fill) + '%';
    if (shipMark) shipMark.classList.toggle('is-done', shipOk);
    if (giftMark) giftMark.classList.toggle('is-done', giftDone);
    if (readdBtn) readdBtn.hidden = !showReadd;
    root.classList.toggle('cart-tiers--single', single);
    root.classList.toggle('is-complete', complete);
    root.hidden = false;
  }

  // Montants des libellés sous la barre (« 49€ Livraison », « 70€ Bubble Mask »).
  var shipAmount = root.querySelector('[data-tiers-amount="ship"]');
  var giftAmount = root.querySelector('[data-tiers-amount="gift"]');
  if (shipAmount) shipAmount.textContent = money(SHIP_CENTS);
  if (giftAmount) giftAmount.textContent = money(GIFT_CENTS);

  document.addEventListener('theme:cart:change', function (e) {
    var cart = e && e.detail ? e.detail.cart : null;
    if (cart && cart.items) { render(cart); cleanupGifts(cart); }
  });
  // Certains ajouts du thème (script « overrideAddToCart » du drawer) n'émettent que cart:updated.
  document.addEventListener('cart:updated', function (e) {
    var cart = e ? e.detail : null;
    if (cart && cart.items) { render(cart); cleanupGifts(cart); }
  });

  document.addEventListener('gwp:declined', function () {
    declinedLocal = true;
    render(lastCart);
  });

  document.addEventListener('gwp:not_discounted', function () {
    giftBlocked = true;
    render(lastCart);
  });
  document.addEventListener('gwp:gift_added', function () {
    giftBlocked = false;
  });

  document.addEventListener('gwp:gift_unavailable', function () {
    giftOff = true;
    root.querySelectorAll('.cart-tiers__labels, [data-tiers-mark="gift"], [data-tiers-readd]').forEach(function (el) {
      el.hidden = true;
    });
    render(lastCart);
  });

  if (readdBtn) {
    readdBtn.addEventListener('click', function (e) {
      e.preventDefault();
      declinedLocal = false;
      setMsg(STRINGS.adding);
      // Le bouton va disparaître : on garde le focus clavier dans la barre.
      if (msgEl && document.activeElement === readdBtn) {
        try { msgEl.focus({ preventScroll: true }); } catch (err) { msgEl.focus(); }
      }
      readdBtn.hidden = true;
      document.dispatchEvent(new CustomEvent('gwp:readd', { bubbles: true }));
    });
  }

  render(lastCart);
  cleanupGifts(lastCart);
})();
